import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import { CopyToClipboard } from '@dixa/lib-shared-habla';
import classnames from 'classnames';
import * as React from 'react';
import { RequestSimulatorFold } from './requestSimulatorFold';
import styles from './requestSimulatorObjectLine.module.scss';
const copyOnClick = (e) => e.stopPropagation();
export const RequestSimulatorObjectLine = ({ objKey, objValue, isArray, path, isLastLine, }) => {
    let commaAtEnd = true;
    if (isLastLine ||
        (objValue &&
            typeof objValue === 'object' &&
            objValue.type &&
            RequestSimulatorFold)) {
        commaAtEnd = false;
    }
    const rootClass = classnames({
        [styles.root]: true,
        [styles.rootCanHover]: typeof objValue === 'object',
    });
    const isObject = typeof objValue !== 'string';
    return (_jsx(CopyToClipboard, Object.assign({ className: rootClass, textToCopy: path, onClick: copyOnClick, disabled: isArray || isObject }, { children: _jsxs("div", { children: [!isArray && !isObject && (_jsxs(React.Fragment, { children: [objKey, ': '] })), objValue, commaAtEnd ? ',' : null, _jsx("span", Object.assign({ className: styles.copyText }, { children: "Copy" })), commaAtEnd ? _jsx("br", {}) : null] }) })));
};
